<div class="page-layout carded fullwidth inner-scroll">
    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->
    <!-- CENTER -->
    <div class="center">
        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0"></h2>
        </div>
        <!-- / CONTENT HEADER -->
        <!-- CONTENT CARD -->
        <div class="content-card">

            <img src="{{urlBanner}}" alt="Logo-Norm35" class="centradoIMG ">

            <!-- / CONTENT TOOLBAR -->
            <!-- CONTENT -->

            <div class="content-card mainDiv" style="margin-top: 2%; margin-left: 2%; margin-right: 2%;">
                <div>
                    <p>{{ 'WIZARD.CT_INFORMACION.Label01' | translate}} </p>
                    <div>
                        <table class="blueTable">
                            <tr>
                                <th>{{ 'WIZARD.CT_INFORMACION.TABLE.LabelTable01' | translate}} </th>
                                <td>
                                    <div>
                                        <textarea style="border: none; width: 100%; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box;" matInput autosize [minRows]="minRows" (blur)="onBlurPractica($event,idSeccionTmp,'requerimiento');" ng-keydown="onBlurPractica()">{{requerimientoTmp}} </textarea>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ 'WIZARD.CT_INFORMACION.TABLE.LabelTable02' | translate}} </th>
                                <td>
                                    <div>
                                        <textarea style="border: none; width: 100%; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box;" matInput autosize [minRows]="minRows" (blur)="onBlurDefinicion($event,idSeccionTmp,'requerimiento');" ng-keydown="onBlurDefinicion()">{{definicionTmp}} </textarea>
                                    </div>
                                </td>
                            </tr>
                        </table><br>
                    </div>
                </div>

                <hr>
            </div>
            <!-- Sección de consultar tareas-->
            <div class="content-card mainDiv" style="margin-top: 2%; margin-left: 2%; margin-right: 2%;">
                <ng-container *ngIf="getInfo">
                    <table class="blueTable" style="width: 100%; margin-top: 1%;">
                        <thead>
                            <tr style="width: 100%;">
                                <th style="width: 15%;">{{ 'WIZARD.TABLE_STEP.TABLE2.EST' | translate}}</th>
                                <th style="width: 9%;"> {{ 'WIZARD.TABLE_STEP.TABLE2.DATE' | translate}}</th>
                                <!--<th style="width: 7%;"> {{ 'WIZARD.TABLE_STEP.TABLE2.NUM' | translate}}</th>-->
                                <th style="width: 19%;">{{ 'WIZARD.TABLE_STEP.TABLE2.ACT' | translate}}</th>
                                <th style="width: 25%;">{{ 'WIZARD.TABLE_STEP.TABLE2.EVD' | translate}}</th>
                                <th style="width: 15%;">{{ 'WIZARD.TABLE_STEP.TABLE2.OBS' | translate}} </th>
                                <!--<th style="width: 10%;">{{ 'WIZARD.TABLE_STEP.TABLE2.DOC' | translate}} </th>-->
                                <!--<th style="width: 7%;">Acciones</th>-->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let primary of primaryTask; let k = index;">
                                <!---selector de estatus -->
                                <td *ngIf="primary.estatus=='Cumple' || primary.estatus=='No aplica' || primary.estatus=='No cumple' " id="{{primary._id+'1'}}">
                                    <mat-form-field style="width: 100%;">
                                        <mat-label>{{primary.estatus}}</mat-label>
                                        <mat-select>
                                            <mat-option [disabled]='validadorMatArchivo[k]' value="Cumple" (click)="doStatus('Cumple',idSeccionTmp,primary._id,primary._id,k,primary.observaciones,primary.archivos,primary.length);activarAlertaob(k);activarAlertaEvi(k)">Cumple</mat-option>
                                            <mat-option value="No cumple" (click)="doStatus('No cumple',idSeccionTmp,primary._id,primary._id,k,primary.observaciones,primary.archivos);activarAlertaob(k);">No cumple</mat-option>
                                            <mat-option value="No aplica" (click)="doStatus('No aplica',idSeccionTmp,primary._id,primary._id,k,primary.observaciones,primary.archivos);activarAlertaob(k);">No aplica</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                                <!-- fin de selector-->

                                <!--COLUMNA DE FECHA-->
                                <td class="tipoCelda cumple alingText" *ngIf="primary.estatus=='Cumple'" id="{{primary._id+'2'}}">{{primary.fechaFin}}</td>
                                <td class="tipoCelda noAp alingText" *ngIf="primary.estatus=='No aplica'" id="{{primary._id+'2'}}">{{primary.fechaFin}}</td>
                                <td class="tipoCelda noCu" *ngIf="primary.estatus=='No cumple'" id="{{primary._id+'2'}}"></td>
                                <!--COLUMNA DE FECHA-->

                                <!--COLUMNA DE DESCRIPCIÓN-->
                                <td class="tipoCelda cumple " *ngIf="primary.estatus=='Cumple'" id="{{primary._id+'6'}}">{{primary.descripcion}}</td>
                                <td class="tipoCelda noAp " *ngIf="primary.estatus=='No aplica'" id="{{primary._id+'6'}}">{{primary.descripcion}}</td>
                                <td class="tipoCelda noCu " *ngIf="primary.estatus=='No cumple' && !statusmater" id="{{primary._id+'3'}}">{{primary.descripcion}}</td>
                                <td class="tipoCelda noCu " *ngIf="primary.estatus=='No cumple' && statusmater==true" id="{{primary._id+'6'}}">
                                    <textarea matInput autosize [minRows]="minRows" (blur)="onPrimaryTask($event,idSeccionTmp,primary._id,1);" ng-keydown="onPrimaryTask()" placeholder="{{ 'WIZARD.TABLE_STEP.TABLE2.DES' | translate}}">{{primary.descripcion}}</textarea>
                                </td>
                                <!--COLUMNA DE DESCRIPCIÓN-->

                                <!-- COLUMNA DE ARCHIVOS-->
                                <td class="tipoCelda cumple" *ngIf="primary.estatus=='Cumple'" id="{{primary._id+'4'}}">
                                    <!--  UPLOAD FILE -->
                                    <div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop (onFileDropped)="uploadFile($event,idSeccionTmp,primary._id,files,k)">
                                        <input hidden type="file" #fileInput (change)="uploadFile($event.target.files,idSeccionTmp,primary._id,files,k)">
                                    </div>
                                    <!--  END UPLOAD FILE -->
                                    <!--SEE FILES-->
                                    <mat-list>
                                        <mat-list-item *ngFor="let arch of primary.archivos; let i = index; last as last">
                                            <a mat-line class="linkArchivo" target="_blank" href="{{pathTmp}}{{arch.rutaArchivo}}" style="word-break: break-all;">{{arch.nombreArchivo}}</a>
                                            <button mat-icon-button (click)="deletePrimaryFile(i,idSeccionTmp,primary._id,arch._id,primary.archivos,k,primary.estatus)"><mat-icon class="mat-24">delete</mat-icon></button>
                                            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
                                        </mat-list-item>
                                    </mat-list>
                                    <!--END SEE FILE-->
                                </td>

                                <td class="tipoCelda noAp" *ngIf="primary.estatus=='No aplica'" id="{{primary._id+'4'}}">
                                    <!--  UPLOAD FILE -->
                                    <div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop (onFileDropped)="uploadFile($event,idSeccionTmp,primary._id,files,k)">
                                        <input hidden type="file" #fileInput (change)="uploadFile($event.target.files,idSeccionTmp,primary._id,files,k)">
                                    </div>
                                    <!--  END UPLOAD FILE -->
                                    <!--SEE FILES-->
                                    <mat-list>
                                        <mat-list-item *ngFor="let arch of primary.archivos; let i = index; last as last">
                                            <a mat-line class="linkArchivo" target="_blank" href="{{pathTmp}}{{arch.rutaArchivo}}" mat-line>{{arch.nombreArchivo}}</a>
                                            <button mat-icon-button (click)="deletePrimaryFile(i,idSeccionTmp,primary._id,arch._id,primary.archivos,k,primary.estatus)"><mat-icon class="mat-24">delete</mat-icon></button>
                                            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
                                        </mat-list-item>
                                    </mat-list>
                                    <!--END SEE FILE-->
                                </td>

                                <td class="tipoCelda noCu" *ngIf="primary.estatus=='No cumple'" id="{{primary._id+'4'}}">
                                    <!--  UPLOAD FILE -->
                                    <div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop (onFileDropped)="uploadFile($event,idSeccionTmp,primary._id,files,k)">
                                        <input hidden type="file" #fileInput (change)="uploadFile($event.target.files,idSeccionTmp,primary._id,files,k)">
                                    </div>
                                    <!--  END UPLOAD FILE -->
                                    <!--SEE FILES-->
                                    <mat-list>
                                        <mat-list-item *ngFor="let arch of primary.archivos; let i = index; last as last">
                                            <a mat-line class="linkArchivo" target="_blank" href="{{pathTmp}}{{arch.rutaArchivo}}">{{arch.nombreArchivo}}</a>
                                            <button mat-icon-button (click)="deletePrimaryFile(i,idSeccionTmp,primary._id,arch._id,primary.archivos,k,primary.estatus)"><mat-icon class="mat-24">delete</mat-icon></button>
                                            <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
                                        </mat-list-item>
                                    </mat-list>
                                    <!--END SEE FILE-->
                                </td>
                                <!-- FIN DE COLUMNAS ARCHIVOS-->

                                <!--Inicio BackGround  dependiendo el select Cumple || No Aplica Observaciones-->
                                <td class="tipoCelda cumple alingText" *ngIf="primary.estatus=='Cumple' " id="{{primary._id+'5'}}">
                                    <textarea id="{{primary._id+'-5'}}" matInput autosize [minRows]="minRows" (blur)="onPrimaryObs($event,idSeccionTmp,primary._id,k)" ng-keydown="onPrimaryObs()" placeholder="{{ 'WIZARD.TABLE_STEP.TABLE2.OBS' | translate}}">{{primary.observaciones}}</textarea>
                                </td>
                                <td class="tipoCelda noAp alingText" *ngIf="primary.estatus=='No aplica'" id="{{primary._id+'5'}}">
                                    <textarea id="{{primary._id+'-5'}}" matInput autosize [minRows]="minRows" (blur)="onPrimaryObs($event,idSeccionTmp,primary._id,k)" ng-keydown="onPrimaryObs()" placeholder="{{ 'WIZARD.TABLE_STEP.TABLE2.OBS' | translate}}">{{primary.observaciones}}</textarea>
                                </td>
                                <td class="tipoCelda noCu alingText" *ngIf="primary.estatus=='No cumple'" id="{{primary._id+'5'}}">
                                    <textarea id="{{primary._id+'-5'}}" matInput autosize [minRows]="minRows" (blur)="onPrimaryObs($event,idSeccionTmp,primary._id,k)" ng-keydown="onPrimaryObs()" placeholder="{{ 'WIZARD.TABLE_STEP.TABLE2.OBS' | translate}}">{{primary.observaciones}}</textarea>
                                </td>


                            </tr>

                            <!--SECCIÓN NUEVA TAREA-->
                            <tr *ngFor="let field of fieldArrayTask2; let i = index;" style="width: 100%;">
                                <td style="width: 16%;"></td>
                                <td style="width: 9%;">
                                    {{ 'WIZARD.TABLE_STEP.TABLE2.DATE' | translate}}
                                </td>
                                <td style="width: 25%;">
                                    <textarea matInput autosize [minRows]="minRows" (blur)="onPrimaryTask($event,idSeccionTmp,IdPrimarytaskTmpFirtsSave,2);" ng-keydown="onPrimaryTask()" placeholder="{{ 'WIZARD.TABLE_STEP.TABLE2.DES' | translate}}"></textarea>
                                </td>
                                <!-- Cargar archivos -->
                                <td style="width: 25%;">
                                    <!--<textarea matInput autosize [minRows]="minRows" (blur)="onPrimaryObs($event,idSeccionTmp,IdPrimarytaskTmpFirtsSave)" ng-keydown="onPrimaryObs()" placeholder="{{ 'WIZARD.TABLE_STEP.TABLE2.FILE' | translate}}" [disabled]="true"></textarea>-->
                                </td>
                                <td style="width: 0%;">
                                    <!--<textarea matInput autosize [minRows]="minRows" (blur)="onPrimaryObs($event,idSeccionTmp,IdPrimarytaskTmpFirtsSave)" ng-keydown="onPrimaryObs()" placeholder="{{ 'WIZARD.TABLE_STEP.TABLE2.OBS' | translate}}" [disabled]="true"></textarea>-->
                                </td>
                            </tr>


                        </tbody>
                    </table>
                    <mat-list>
                        <!-- *ngIf="statusmater==true" -->
                        <mat-list-item *ngIf="statusmater">
                            <button mat-icon-button aria-label="" (click)="addFieldValuePrimaryTask(idSeccionTmp)">
                                <mat-icon matTooltip="{{ 'WIZARD.TABLE_STEP.TABLE2.TASK' | translate}}" style="font-size: 60px; color: #188FBF;">add_circle_outlin</mat-icon>
                            </button>
                            <p mat-line>{{ 'WIZARD.TABLE_STEP.SPAN01' | translate}}</p>
                        </mat-list-item>
                    </mat-list>
                </ng-container>


            </div>
            <hr>
            <hr>
            <!--<div *ngIf=" dataId.id==d atita.position ">-->
        </div>
        <!-- / CONTENT -->
    </div>
    <!-- / CONTENT CARD -->
</div>
<!-- / CENTER -->